import { Injectable, Injector } from '@angular/core';
import { Namespace } from 'enums-lib';
import { ISignatureProviderService } from '../../interfaces/isignatureproviderservice';
import { DocusignSignatureProviderService } from '../signature-providers/docusign/docusign-signature-provider.service';
import { BullhornServiceProviderService } from './bullhorn-service-provider.service';
import { InveniasServiceProviderService } from './invenias-service-provider.service';
import { IServiceProviderService } from './iserviceproviderservice';
import { SalesforceServiceProviderService } from './salesforce-service-provider.service';

@Injectable({ providedIn: 'root' })
export class ServiceProviderServiceFactory {
  constructor(private injector: Injector) {}

  getServiceProviderService(namespace: string | Namespace): IServiceProviderService {
    if (namespace === Namespace.invenias) {
      return this.injector.get(InveniasServiceProviderService);
    }

    if (namespace === Namespace.bullhorn) {
      return this.injector.get(BullhornServiceProviderService);
    }

    if (namespace === Namespace.salesforce) {
      return this.injector.get(SalesforceServiceProviderService);
    }

    throw new Error(`No service provider service found for '${namespace}'`);
  }

  getSignatureProviderService(providerName: string): ISignatureProviderService {
    if (providerName === 'docusign') {
      return this.injector.get(DocusignSignatureProviderService);
    }

    throw new Error(`No signature provider service found for '${providerName}'`);
  }
}
